import "date-fns";
import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import withStyles from "@material-ui/core/styles/withStyles";

import DateFnsUtils from "@date-io/date-fns";
import {
   MuiPickersUtilsProvider,
   KeyboardDatePicker
 } from "@material-ui/pickers";
import Slider from "@material-ui/core/Slider";

const AntTabs = withStyles({
  indicator: {},
})(Tabs);
const AntTab = withStyles((theme) => ({
  root: {
    textTransform: 'none',
    minWidth: 100,
    fontSize: 12,
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: 0,
    opacity: 0.6,
    '&:hover': {
      opacity: 1,
    },
    '&$selected': {
      fontWeight: theme.typography.fontWeightMedium,
      outline: 'none',
    },
    '&:focus': {
      outline: 'none',
    },
  },
  selected: {},
}))((props) => <Tab disableRipple {...props} />);
const useStyles = makeStyles(theme => ({
  root: {
    minWidth: 100,

  },
  row: {
    marginTop: 15,
    
  },
  spacer: {
    flexGrow: 3
  },
  importButton: {
    marginRight: 15
  },
  exportButton: {
    marginRight: 15
  },
  searchInput: {
    marginRight: 15
  },
  formControl: {
    margin: 25,
    fullWidth: true,
    display: "flex",
    wrap: "wrap"
  },
  date: {
    display: 'flex',
    marginTop: 0,
    // minWidth: 20,
    alignItems:'baseline'
  },
  range: {
    marginTop: 13
  }
}));

const Toolbar = props => {
  const { className,
    startDate,
   setStartDate,
   finishDate,
   setFinishDate,
   priceFilter,
   setPriceFilter,
    statusFilter,
    setStatusFilter,
    tabs,
    ...rest } = props;
  const [tabValue, setTabValue] = React.useState(statusFilter);
  const [rangeValue, rangeSetValue] = React.useState(priceFilter);

  const classes = useStyles();

  const handleChangeTab = (e, value) => {
    setTabValue(value);
    setStatusFilter(value);
    
  };

  const handleDateChange = (date) => {
    setStartDate(date);
  };
  const handleDateChangeFinish = (date) => {
    setFinishDate(date);
  };
 const handleChangeRange = (event, newValue) => {
   rangeSetValue(newValue);
 };
 const setRangeFilter = (event, newValue) => {
   setPriceFilter(newValue);
 };

  return (
    <div
      {...rest}
      className={className}
    >
      <Grid container spacing={4}>
        <Grid
          item
          lg={'auto'}
          sm={'auto'}
          xl={'auto'}
          xs={'auto'}
          m={'auto'}
        >
          <div className={classes}>
            <AntTabs value={tabValue} onChange={(e,value) => {handleChangeTab(e,value)}} aria-label="ant example">
              {tabs.map((item) => (<AntTab key={item} label={item} />))}
            </AntTabs>
         
          </div>
        </Grid>
        <Grid
          className={classes.date}
          item
          lg={'auto'}
          sm={'auto'}
          xl={'auto'}
          xs={'auto'}
          m={'auto'}
        >
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <Grid container justify="space-around">
              <KeyboardDatePicker
                id="date-picker-dialog"
                variant="inline"
                label={<span style={{opacity: 0.6}}>Start Date</span>}
                format="MM/dd/yyyy"
                value={startDate}
                onChange={handleDateChange}
                KeyboardButtonProps={{
                  "aria-label": "change date"
                }}
              />          
                          
         </Grid>
          </MuiPickersUtilsProvider>

          
        </Grid>
        <Grid
        className={classes.date}
        item
        lg={'auto'}
        sm={'auto'}
        xl={'auto'}
        xs={'auto'}
        m={'auto'}
           >
           <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <KeyboardDatePicker
                id="date-picker-dialog-finish"
                variant="inline"
                label={<span style={{opacity: 0.6}}>Finish Date</span>}
                format="MM/dd/yyyy"
                value={finishDate}
                onChange={handleDateChangeFinish}
                KeyboardButtonProps={{
                  "aria-label": "change date"
                }}
                />
                </MuiPickersUtilsProvider>
          
        </Grid>
        </Grid>
     
    </div>
  );
};

Toolbar.propTypes = {
  className: PropTypes.string
};

export default Toolbar;
